import React from 'react';
import Descriptions from '@/components/Descriptions';

function ProducerInfo({ infoData }) {
  return (
    <Descriptions title='生产信息' emptySuffix='-'>
      <Descriptions.Item label='生产者ID' value={infoData?.producerId} />
      <Descriptions.Item label='生产者名称' value={infoData?.producerName} />
      <Descriptions.Item label='生产者地址' value={infoData?.producerAddress} />
      <Descriptions.Item
        label='生产时间'
        value={infoData?.messageClientPublishTime}
        type='dateMillionTime'
      />
    </Descriptions>
  );
}

export default ProducerInfo;
